<script>
import axios from "axios";

export default {
  props: {
    visible: {
      required: false,
      default: false,
    },
    documento: {
      type: Object,
      required: true,
    },
  },
  emits: ["refetch", "close-modal"],
  data() {
    return {
      selected: {
        status: undefined,
      },
    };
  },
  methods: {
    async updateStatus() {
      const query = {
        estado: this.selected.status,
      };

      try {
        const { status } = await axios.post(
          `/api/admin/documentos/${this.documento.id}/validar-vb`,
          query
        );

        if (status == "200") {
          this.$emit("refetch");
          this.$emit("close-modal");
        }
      } catch (e) {
        console.error("There was a problem updating a document status:", e);
      }
    },
  },
  watch: {
    visible: function (newValue) {
      if (newValue == true) {
        this.selected.status = this.documento?.base?.estado;
      }
    },
  },
};
</script>

<template>
  <b-modal v-model="visible">
    <template #modal-title> Cambiar estado </template>
    <div class="flex flex-col gap-4">
      <select v-model="selected.status">
        <option disabled value="Pendiente">Pendiente</option>
        <option value="Aprobado">Aprobado</option>
        <option value="Inmovilizado">Inmovilizado</option>
        <option value="Pendiente de Inspección">Pendiente de Inspección</option>
        <option value="Presentado">Presentado</option>
        <option value="Rechazado">Rechazado</option>
      </select>
    </div>

    <template #modal-footer>
      <div class="flex flex-row items-center gap-2 justify-end">
        <button class="btn-cancelar" @click="() => $emit('close-modal')">
          Cancelar
        </button>
        <button class="btn-principal" @click="updateStatus()">Guardar</button>
      </div>
    </template>
  </b-modal>
</template>
